<template>
  <div>
    <rich-button
      class="item-btn"
      :inline="true"
      @click="handleAdd">
    {{gettext('邀请')}}<i class="c-common_icon_back"></i>
    </rich-button>
    <!-- 购买半浮层 -->
     <half-popup
      :title="gettext('邀请')"
      :isShow="isShow"
      @clickMask="clickMask"
      >
      <div slot="content">
        <div class="share">
          <div class="code-box">
            <p class="code-box-title">{{_('通过SNS邀请')}}</p>
            <div class="copy-wrap">
              <span class="code">{{acquisitionInfo.recommendCode}}</span>
              <span
                v-if="clipboard"
                class="copy-btn"
                :data-clipboard-text="copyContent"
                @click="copyHandle"
              >
              </span>
            </div>
          </div>
          <div class="share-box">
            <div class="title">{{gettext('将优惠分享到')}}</div>
            <share :config="shareConfig" :shortLink="true" @trackShareClick="trackShareClick" />
          </div>
        </div>
      </div>
     </half-popup>
  </div>
</template>

<script>
import Clipboard from 'clipboard'
import HalfPopup from '@/components/half-popup/index'
import Share from '@/page/c/xtc/modules/share.vue'
import { debounce, getUrlLanguage } from '@/common/js/utils'
import { mapGetters } from 'vuex'
import { getShareConfig } from '@/page/c/xtc/utils'
import { get } from 'lodash-es'
import { cgcCardInviteCk, landingCgcPopupSw, cgcCopyPopupCk, cgcSharePopupCk } from '../../track'

export default {
  name: 'inviteBtn',
  props: {
    inviteData: {
      type: Object,
      default: {}
    }
  },
  components: {
    HalfPopup,
    Share
  },
  data () {
    return {
      isShow: false,
      isLogin: false,
      clipboard: null,
      shareConfig: {
        config: {},
        order: []
      }
    }
  },
  computed: {
    ...mapGetters({
      acquisitionInfo: 'acquisitionInfo'
    }),
    country () {
      return this.$store.state.country
    },
    hostName () {
      // 巴西使用99域名,墨西哥使用didi域名
      return GlobalConfig[this.country].hostname || 'act.didi-food.com'
    },
    copyContent () {
      return `${get(this.acquisitionInfo, 'recommendPage.share.referralCode')}https://${this.hostName}/${getUrlLanguage()}/c/participateShare?share=1&code=${this.acquisitionInfo.recommendCode}&activityType=${this.inviteData.activityType}&activityId=${this.acquisitionInfo.activityID}&countryCode=${this.country}`
    },
    shareUrl () {
      return `${window.location.protocol}//${window.location.host}/${getUrlLanguage()}/c/participateShare?share=1&code=${this.acquisitionInfo.recommendCode}&activityType=${this.inviteData.activityType}&activityId=${this.acquisitionInfo.activityID}&poiLat=${this.inviteData.poiLat}&poiLng=${this.inviteData.poiLng}&countryCode=${this.country}`
    }
  },
  mounted () {
    this.initClipBoard()
    this.getAcquisitionInfo()
  },
  beforeDestroy () {
    this.clipboard && this.clipboard.destroy()
  },
  methods: {
    async getAcquisitionInfo () {
      let recommendPage = this.acquisitionInfo.recommendPage || {}
      this.shareConfig.config = await getShareConfig(recommendPage.share, this.shareUrl, recommendPage.shareOrder)
      // 根据服务端下发展示顺序过滤用户侧主面板所展示的分享渠道
      this.shareConfig.order = recommendPage.shareOrder
    },

    trackShareClick (plantform) {
      cgcSharePopupCk({
        share_type: plantform
      })
    },

    copyHandle: debounce(function () {
      cgcCopyPopupCk()
      this.clipboard.on('success', e => {
        const toast = this.$createToast({
          time: 1000,
          txt: this.gettext('复制成功'),
          type: 'correct'
        })
        toast.show()
        e.clearSelection()
      })
      this.clipboard.on('error', e => {
        const toast = this.$createToast({
          time: 1000,
          txt: this.gettext('该浏览器不支持自动复制'),
          type: 'error'
        })
        toast.show()
        e.clearSelection()
      })
    }, 200),

    initClipBoard () {
      // TODO: 不支持clipboard兼容
      if (Clipboard.isSupported()) {
        this.clipboard = new Clipboard('.copy-btn')
      }
    },
    // 兑换弹窗
    handleAdd () {
      this.isShow = true
      cgcCardInviteCk()
      landingCgcPopupSw()
      this.$emit('couponsShow', true)
    },
    clickMask () {
      this.isShow = false
      this.$emit('couponsShow', false)
    }
  }
}
</script>

<style lang="stylus" scoped>
@import "~@/common/stylus/variables";
@import '~@/common/stylus/mixin.styl';
.item-btn{
    padding: 24px 40px;
    min-width: 288px;
    i{
      font-size: 32px;
      transform: rotate(180deg);
      display: inline-block;
      vertical-align: middle;
      margin-left: -10px;
    }
  }
.share {
  margin: 20px 0
  padding: 48px 0
  border-radius: 12px
  background: #ffffff
  .code-box {
    padding-bottom 48px
    border-bottom 1px solid #EBEBEB
    .code-box-title {
      font-family: 'Aspira Light';
      font-size: 28px;
      color: #000000;
      text-align: left;
    }
    .copy-wrap {
      margin-top: 48px;
      display flex
      align-items center
      justify-content flex-start
      .copy-btn {
        display: inline-block
        width: 40px
        height: 40px
        line-height: 40px
        white-space: nowrap
        copy-icon()
        margin-left: 12px
        box-sizing: border-box
        font-size: 28px
        font-color()
      }
      .code {
        font-family: 'Aspira Medium'
        font-size: 48px
        color: #000000
        letter-spacing: 0
        text-align: center
        font-weight: bold
        -webkit-user-select: text
      }
    }
  }
  .share-box {
    margin 48px 0 0
    .title {
      font-family: 'Aspira Light';
      font-size: 28px;
      color: #000000;
      text-align: left;
      margin-bottom 18px
    }
    & /deep/ .icons {
      padding 0
      justify-content space-between
      .icon {
        width 90px
        height 90px
        margin-left 0!important
        img {
          width 90px
          height 90px
        }
      }
    }
  }
}
</style>
<style>
.half-content .share .icons{
  justify-content: space-between!important;
  padding: 0 0 15px!important;
}
.half-content .share .icons .icon img{
  width: 90px!important;
  height: 90px!important;
}
</style>
